import { ChartBuilder } from 'Molecules/InsightsChart/chartBuilder';
import { ChartType } from '../chartTypes';
import { BarChartData } from 'Molecules/InsightsChart/chartBuilder';
import { BaseInsightPayload } from '../InsightDataPayload';
import { parseCapacityManagementEstimatedVsActualHoursUsersPayload } from '../payloads/capacityManagementEstimatedVsActualHoursUsersPayload';
import { InsightChartFactory } from '../insightChartFactory';
import DefaultChartWithTrendSupport from 'Molecules/InsightsChart/DefaultChartWithTrendSupport';
import intl from 'react-intl-universal';

export const buildCapacityManagementEstimatedVsActualHoursUsersInsightFactory =
  (payload: BaseInsightPayload): InsightChartFactory => {
    const parsedPayload =
      parseCapacityManagementEstimatedVsActualHoursUsersPayload(payload);
    const { data } = parsedPayload.data.attributes;

    return (props) => {
      const chart = new ChartBuilder()
        .setChartType(ChartType.V_BAR_MULTI)
        .setProps({
          chartData: data as BarChartData,
          onDrillDown: props.onDrillDown,
          xAxisFieldName: 'user_name',
          yAxisFieldNames: [
            'allocated_hours_in_range',
            'actual_hours_in_range',
          ],
          legendNames: [
            intl.get('INSIGHT.LEGEND.ALLOCATED_HOURS'),
            intl.get('INSIGHT.LEGEND.ACTUAL_HOURS'),
          ],
        })
        .build();

      return DefaultChartWithTrendSupport({
        chartComponent: chart,
      });
    };
  };
